export abstract class BPCmd {

	abstract clone()

	abstract toArray(): any[]
}
